import React from "react";

const SelectYearFromRange = ({
  value,
  onChange,
  startYear,
  endYear,
  error,
  readOnly = false,
}) => {
  const errorClass = error ? "year-select validation-error" : "year-select";

  const generateYearList = () => {
    const yearList = [];

    for (let year = startYear; year <= endYear; year++) {
      yearList.push(year);
    }
    return yearList;
  };

  return (
    <select disabled={readOnly} className={errorClass} onChange={onChange}>
      {generateYearList().map((year, index) => (
        <option key={`year${index}`} value={year} selected={year === value}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default SelectYearFromRange;
